var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasText)?_c('span',{staticClass:"select-tag",style:(_vm.pillStyle)},[(_vm.dot)?_c('span',{staticClass:"select-tag__dot",style:(_vm.dotStyle)}):_vm._e(),_c('span',{staticClass:"select-tag__text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }